export const NOTIFICATIONS = 'FETCH_NOTIFICATIONS' ;
export const NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR' ;
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATIONS';
export const DEFAULT = 'DEFAULT';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
